// The BreezeTask chat widget (injected via Tracking Code Manager) renders inside a shadow root with
// large, invisible position:fixed elements that swallow touches on the page beneath them (e.g. the
// video slider on mobile). Make the whole widget click-through, then re-enable only its controls.
class ChatWidgetFix {

  // light-DOM element hosting the widget's shadow root
  static hostId = 'bsw-widget-root';

  static styleId = 'chat-widget-touch-fix';

  static css = `
    a, button, input, textarea, select, label, iframe,
    [role="button"], [tabindex]:not([tabindex="-1"]) {
      pointer-events: all;
    }
  `;

  static init () {
    // the widget loads asynchronously, so keep watching until its shadow root shows up
    if ( this.apply() ) return;
    const observer = new MutationObserver( () => {
      if ( this.apply() ) observer.disconnect();
    });
    observer.observe( document.body, { childList: true, subtree: true } );
  }

  // returns true once the host has been patched
  static apply () {
    const host = document.getElementById( this.hostId );
    // a closed root returns null here; leave it alone rather than disabling the widget outright
    const root = host?.shadowRoot;
    if ( !root ) return false;
    if ( !root.getElementById( this.styleId ) ) {
      const style = document.createElement('style');
      style.id = this.styleId;
      style.textContent = this.css;
      root.appendChild( style );
    }
    // pointer-events inherits into the shadow tree, including its position:fixed children
    host.style.setProperty( 'pointer-events', 'none', 'important' );
    return true;
  }

}

document.addEventListener( 'DOMContentLoaded', () => ChatWidgetFix.init() );